function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { AlertsBus } from 'modules/App';
import messages from '../../../messages';
import { useFormValues } from './hooks';
import Actions from './Actions';
import AddressInformation from './AddressInformation';
import BasicInformation from './BasicInformation';
import MembershipInformation from './MembershipInformation';
const Summary = ({ StepsElement, organizationProposal, onChangeView })=>{
    const formValues = useFormValues(organizationProposal);
    return /*#__PURE__*/ _jsxs("section", {
        className: "section",
        children: [
            StepsElement,
            /*#__PURE__*/ _jsx("p", {
                className: "text--paragraph mb-7",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.intros.create.summary))
            }),
            /*#__PURE__*/ _jsx(AlertsBus, {
                className: "mb-6"
            }),
            /*#__PURE__*/ _jsx(BasicInformation, {
                formValues: formValues
            }),
            /*#__PURE__*/ _jsx(AddressInformation, {
                formValues: formValues
            }),
            /*#__PURE__*/ _jsx(MembershipInformation, {
                formValues: formValues
            }),
            /*#__PURE__*/ _jsx(Actions, {
                organizationProposal: organizationProposal,
                onChangeView: onChangeView
            })
        ]
    });
};
export default Summary;
